import { render, staticRenderFns } from "./storeInfoReadonly.vue?vue&type=template&id=4d1572c5&"
import script from "./storeInfoReadonly.vue?vue&type=script&lang=babel&"
export * from "./storeInfoReadonly.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports